import { compose } from 'redux';
// import { branch } from '../../common/utils/general/branch';
import { ListContainerNew } from '../../common/containers';

import { withErrorAndNoDataComponents } from './helpersListContainer';

export const ListContainer = function (WrappedComponent) {
	return compose(
		withErrorAndNoDataComponents,
		ListContainerNew,
	)(WrappedComponent);
};
